module.exports = __webpack_public_path__ + "img/40_00_079_459.4971a441.jpg";